<div>

  <h3> {{ 'masterdetail.offerfee' | translate }} </h3>

  <ct-model *ngIf="modelConfiguration" [configuration]="modelConfiguration"></ct-model>

</div>

<ng-template #AmountCellTemplate let-row="row">

  <p>{{row.Amount}} {{row.AmountType === 2 ? '%' : '€'}}</p>

</ng-template>
